<div class="two-factor-prompt-prosuite" role="dialog" aria-labelledby="tfa-title" aria-describedby="tfa-message">
  <!-- Header -->
  <div class="popup-header-enhanced">
    <div class="header-content">
      <h4 id="tfa-title" class="header-title">
        <mat-icon class="header-icon">lock</mat-icon>
        {{ title }}
      </h4>
      <button type="button"
        class="close-button-enhanced"
        (click)="onCancel()"
        aria-label="Close 2FA prompt">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div mat-dialog-content class="dialog-content-enhanced">
    <p id="tfa-message" class="primary-message">{{ message }}</p>

    <div class="code-input-container">
      <label for="tfa-code" class="code-label">Verification Code</label>
      <input id="tfa-code"
        type="text"
        class="code-input"
        [class.has-error]="errorMessage"
        maxlength="6"
        inputmode="numeric"
        pattern="[0-9]*"
        autocomplete="one-time-code"
        placeholder="000000"
        [value]="code"
        (input)="onCodeInput($event)"
        (keydown.enter)="onVerify()" />
      @if (errorMessage) {
        <div class="error-message">
          <mat-icon class="error-icon">error_outline</mat-icon>
          {{ errorMessage }}
        </div>
      }
    </div>
  </div>

  <!-- Actions -->
  <div mat-dialog-actions class="dialog-actions-enhanced">
    <button mat-raised-button
      class="action-btn action-btn-cancel"
      (click)="onCancel()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>

    <button mat-raised-button
      class="action-btn action-btn-confirm"
      [disabled]="!isValid"
      (click)="onVerify()">
      <mat-icon>verified_user</mat-icon>
      Verify
    </button>
  </div>
</div>
